"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTermsAndConditionsResponse = exports.CreateTermsAndConditionsResponse = exports.CreateTermsAndConditionsRequest = void 0;
const zod_1 = require("zod");
exports.CreateTermsAndConditionsRequest = zod_1.z.object({
    value: zod_1.z.string(),
});
exports.CreateTermsAndConditionsResponse = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
    }),
});
exports.GetTermsAndConditionsResponse = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
        value: zod_1.z.string(),
        createdAt: zod_1.z.string().date(),
    }),
});
